import { InviteNewMemberGuide } from "../guides/invite-new-member-guide";
import { PushNotificationGuide } from "../guides/push-notification-guide";
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from "../ui/accordion";

export function Dashboard() {
	return (
		<div className="flex flex-col gap-4">
			<h2 className="text-2xl font-bold">Dashboard</h2>
			<h3 className="text-xl">Guides</h3>
			<Accordion className="border p-2">
				<AccordionItem value="item-1">
					<AccordionTrigger>Push Notification Guide</AccordionTrigger>
					<AccordionContent>
						<PushNotificationGuide />
					</AccordionContent>
				</AccordionItem>
				<AccordionItem value="item-2">
					<AccordionTrigger>Invite New Member Guide</AccordionTrigger>
					<AccordionContent>
						<InviteNewMemberGuide />
					</AccordionContent>
				</AccordionItem>
			</Accordion>
		</div>
	);
}
